export default __webpack_public_path__ + "static/media/RbtLogo.8b700eb0.svg";